import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  closeJwtEditorModal,
  createRpcJwtTokenAsync,
  selectIsOpenJwtEditorModal,
  selectJwtCreateLoading,
} from "../../../store/rpc/rpcSlice";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { RpcJwtSchema } from "../../../utils/validations";
import { Button, Textarea, Modal, Input } from "djuno-design";
import { useCallback, useEffect } from "react";

const JwtEditorModal = () => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectIsOpenJwtEditorModal);
  const loading = useAppSelector(selectJwtCreateLoading);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(RpcJwtSchema),
  });

  const onSubmit = (data: any) => {
    dispatch(
      createRpcJwtTokenAsync({
        id: 1,
        name: data.name,
        publicKey: data.publicKey,
      })
    ).then((action) => {
      if (action.type === "rpc/jwt-token/create/fulfilled") {
        reset();
        //TODO: fetch new data
        dispatch(closeJwtEditorModal());
      }
    });
  };

  const handleOnClose = useCallback(() => {
    reset();
    dispatch(closeJwtEditorModal());
  }, [dispatch, reset]);

  useEffect(() => {
    return () => {
      handleOnClose();
    };
  }, [handleOnClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      contentClassName="max-w-2xl"
      //   containerClassName="!items-start"
      title="Add a JSON Web Token"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-5">
          <Input
            label="Name"
            {...register("name")}
            error={errors.name?.message}
            placeholder=""
            required
          />
        </div>
        <div className="mt-5">
          <Textarea
            label="Public Key"
            {...register("publicKey")}
            rows={7}
            error={errors.publicKey?.message}
            className="text-xs"
            placeholder="-----BEGIN PUBLIC KEY-----"
            required
          />
        </div>

        <div className="mt-4 flex justify-end">
          <Button
            className="w-10"
            uiType="primary"
            disabled={loading}
            type="submit"
            loading={loading}
          >
            Create
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default JwtEditorModal;
